const toggleSidebar = (state) => ({
  type: 'TOGGLE_SIDEBAR',
  state,
});

export {
  toggleSidebar,
}
